import { CircularProgress, Box } from '@mui/material';

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  size?: number;
  message?: string;
}

export const LoadingSpinner = ({ 
  fullScreen = false, 
  size = 40,
  message 
}: LoadingSpinnerProps) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={size} />
        {message && (
          <Box sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            {message}
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
